export default __webpack_public_path__ + "static/media/search-btn.845ab634.svg";